module.exports = __webpack_public_path__ + "img/80ne.08544288.svg";